import { createFileRoute } from '@tanstack/react-router';

import { SavedQueriesPage } from '@/features/saved-queries/ui/saved-queries.page';

export const Route = createFileRoute('/workspace/$workspaceId/listening')({
  component: () => <SavedQueriesPage />,
});
